import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { ReactSortable } from "react-sortablejs";
import { FormikErrors } from "formik";
import { Col, Input, Label } from "reactstrap";
import ModalConfirm from "./ModalConfirm";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import { toast } from "react-toastify";
import DropdownStatusNew from "./DropdownStatusNew";
import ModalEditContent from "./ModalEditContent";

interface ContentDetailFormArrayProps {
  formik: any;
}

const PARAM_DEFAULT = {
  title: "",
  content: "",
  status: false,
  id: 1,
};

const ContentDetailFormArray = ({
  formik = "",
}: ContentDetailFormArrayProps) => {
  const { t } = useTranslation();
  const [isOpenConfirm, setIsOpenConfirm] = useState<boolean>(false);
  const [indexDelete, setIndexDelete] = useState<any>(null);
  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);
  const [isOpenEdit, setOpenEdit] = useState<any>();

  const onCloseEdit = () => {
    setOpenEdit(null);
  };

  const handleSubmitEdit = () => {
    setOpenEdit(null);
  };

  const handleChangeSort = (data: any[]) => {
    const formatData = data?.map((item, index) => ({
      title: item?.title,
      content: item?.content,
      status: item?.status,
      id: item?.id,
    }));
    formik.setFieldValue("content", formatData);
  };
  const onCloseConfirmClick = () => {
    setIsOpenConfirm(false);
    setIndexDelete(null);
    setIsConfirmLoading((_prev) => false);
  };

  const handleAddItem = () => {
    formik.setFieldValue("content", [
      ...formik?.values?.content,
      {
        ...PARAM_DEFAULT,
        id: formik?.values?.content?.length + 1,
        ordering: formik?.values?.content?.length + 1,
      },
    ]);
  };

  const handleRemoveItem = (index: number) => {
    const updatedItems = formik?.values?.content.filter(
      (_: any, i: any) => i !== index
    );
    formik.setFieldValue("content", updatedItems);
  };

  const handleActionDelete = async () => {
    try {
      handleRemoveItem(indexDelete);
      setIsOpenConfirm(false);
      toast(
        `${t("The process has been completed.")}`,
        CONFIG_OPTION_TOAST_NORMAL
      );
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      setIndexDelete(null);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
    setIsConfirmLoading((_prev) => false);
  };

  return (
    <React.Fragment>
      <>
        <Col lg={12}>
          {/* <Label htmlFor="titleKoreaInput" className="form-label">
            {t("Content")} <span className="text-danger"></span>
          </Label> */}

          <table className="w-100">
            <thead>
              <tr style={{ background: "#EDEDED", height: "37px" }}>
                <th style={{ width: 40 }}></th>
                <th style={{ width: 60 }}>{t("Status")}</th>
                <th>{t("Section Name")}</th>
                <th>{t("Content")}</th>
                {/* <th>{t("Fold")}</th>
                <th>{t("Desktop")}</th> */}
                <th>{t("")}</th>
              </tr>
            </thead>
            <ReactSortable
              animation={200}
              delay={2}
              tag={"tbody"}
              filter={".locked_item"}
              preventOnFilter={false}
              list={formik?.values?.content as any[]}
              setList={handleChangeSort}
              onMove={(evt) => !evt.related.classList.contains("locked_item")}
              handle={".my-handle"}
            >
              {formik?.values?.content?.map((item: any, index: number) => {
                return (
                  <tr key={`${item?.id}`}>
                    <td
                      className="my-handle text-center"
                      style={{
                        paddingRight: "10px",
                        paddingTop: "15px",
                        paddingBottom: "5px",
                        verticalAlign: "top",
                      }}
                    >
                      {" "}
                      <i className="ri-menu-line"></i>
                    </td>
                    <td
                      style={{
                        paddingRight: "10px",
                        paddingTop: "15px",
                        paddingBottom: "5px",
                        verticalAlign: "top",
                      }}
                    >
                      <div
                        className="form-check form-switch form-switch-sm text-center"
                        dir="ltr"
                      >
                        <input
                          type="checkbox"
                          className="form-check-input"
                          name={`content.${index}.status`}
                          checked={item?.status === 1 ? true : false}
                          onChange={(e) => {
                            formik.setFieldValue(
                              `content.${index}.status`,
                              e?.target?.checked === true ? 1 : 0
                            );
                          }}
                        />
                      </div>
                    </td>
                    <td
                      style={{
                        paddingRight: "10px",
                        paddingTop: "5px",
                        paddingBottom: "5px",
                        verticalAlign: "top",
                      }}
                    >
                      <Input
                        name={`content.${index}.title`}
                        type="text"
                        className="form-control"
                        placeholder={t("Enter section name")}
                        max={16}
                        value={item?.title}
                        onBlur={(event) => {
                          formik.handleBlur(event);
                        }}
                        onChange={(event) => {
                          formik.setFieldValue(
                            `content.${index}.title`,
                            event?.target?.value
                          );
                        }}
                      />
                      {formik.touched.content?.[index]?.title &&
                      formik.errors.content &&
                      (formik.errors.content[index] as FormikErrors<any>)
                        ?.title ? (
                        <small className="text-danger mt-2">
                          {(formik.errors.content[index] as any)?.title}
                        </small>
                      ) : null}
                    </td>

                    <td
                      style={{
                        paddingRight: "10px",
                        paddingTop: "5px",
                        paddingBottom: "5px",
                        verticalAlign: "baseline",
                      }}
                    >
                      <Input
                        name={`content.${index}.content`}
                        type="text"
                        className="form-control"
                        max={16}
                        value={item?.content}
                        placeholder={t("Enter the content")}
                        readOnly
                        onClick={() => {
                          setOpenEdit({
                            title: t("Content"),
                            width: "1200px",
                            height: "812px",
                            value: item?.content || "",
                            cb: (event: any) => {
                              formik.setFieldValue(
                                `content.${index}.content`,
                                event
                              );
                            },
                          });
                        }}
                      />
                      {formik.touched.content?.[index]?.content &&
                      formik.errors.content &&
                      (formik.errors.content[index] as FormikErrors<any>)
                        ?.content ? (
                        <small className="text-danger mt-2">
                          {(formik.errors.content[index] as any)?.content}
                        </small>
                      ) : null}
                    </td>
                    {/* <td
                      style={{
                        paddingRight: "10px",
                        paddingTop: "5px",
                        paddingBottom: "5px",
                        verticalAlign: "baseline",
                      }}
                    >
                      <Input
                        name={`content.${index}.fold`}
                        type="text"
                        className="form-control"
                        placeholder={t("Enter the content")}
                        max={16}
                        value={item?.fold}
                        readOnly
                        onClick={() => {
                          setOpenEdit({
                            title: `${item?.title} Content - For Fold`,
                            width: "768px",
                            height: "1024px",
                            value: item?.fold || "",
                            cb: (event: any) => {
                              formik.setFieldValue(
                                `content.${index}.fold`,
                                event
                              );
                            },
                          });
                        }}
                      />
                      {formik.touched.content?.[index]?.fold &&
                      formik.errors.content &&
                      (formik.errors.content[index] as FormikErrors<any>)
                        ?.fold ? (
                        <small className="text-danger mt-2">
                          {(formik.errors.content[index] as any)?.fold}
                        </small>
                      ) : null}
                    </td>

                    <td
                      style={{
                        paddingRight: "10px",
                        paddingTop: "5px",
                        paddingBottom: "5px",
                        verticalAlign: "baseline",
                      }}
                    >
                      <Input
                        name={`content.${index}.desktop`}
                        type="text"
                        className="form-control"
                        max={16}
                        value={item?.desktop}
                        placeholder={t("Enter the content")}
                        readOnly
                        onClick={() => {
                          setOpenEdit({
                            title: `${item?.title} Content - For Desktop`,
                            width: "1440px",
                            height: "900px",
                            value: item?.desktop || "",
                            cb: (event: any) => {
                              formik.setFieldValue(
                                `content.${index}.desktop`,
                                event
                              );
                            },
                          });
                        }}
                      />
                      {formik.touched.content?.[index]?.desktop &&
                      formik.errors.content &&
                      (formik.errors.content[index] as FormikErrors<any>)
                        ?.desktop ? (
                        <small className="text-danger mt-2">
                          {(formik.errors.content[index] as any)?.desktop}
                        </small>
                      ) : null}
                    </td> */}
                    <td style={{ verticalAlign: "top" }}>
                      <div
                        className="d-flex pt-2"
                        style={{ justifyContent: "center" }}
                      >
                        <div>
                          {
                            <div
                              className="text-danger cursor-pointer"
                              onClick={() => {
                                setIsOpenConfirm(true);
                                setIndexDelete(index);
                              }}
                            >
                              <i className="ri-delete-bin-3-fill align-bottom"></i>
                            </div>
                          }
                        </div>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </ReactSortable>
          </table>
        </Col>
        {formik.touched?.content && formik.errors?.content ? (
          <small className="text-danger mt-2">
            {typeof formik.errors?.content === "string" &&
              formik.errors?.content}
          </small>
        ) : null}

        <Col lg={12} className="mb-2">
          <div
            className="text-primary text-center cursor-pointer mt-3 d-flex align-items-center justify-content-center gap-2"
            style={{ fontSize: 30, background: "#0bcee91c" }}
            onClick={handleAddItem}
          >
            + <span style={{ fontSize: 14 }}>{t("Add Content")}</span>
          </div>
        </Col>
      </>

      <ModalConfirm
        header={t("Delete this content")}
        isOpen={isOpenConfirm}
        isLoading={isConfirmLoading}
        onClose={onCloseConfirmClick}
        onConfirm={handleActionDelete}
      />

      <ModalEditContent
        header={isOpenEdit?.title || t("Content")}
        isOpen={isOpenEdit}
        onClose={onCloseEdit}
        onConfirm={handleSubmitEdit}
      />
    </React.Fragment>
  );
};

export default ContentDetailFormArray;
